<template>
  <div id="dashboard">
    <div>
      <Navigation />
      <Weather v-if="dashboard.panel == 'weather'" />
      <TrailHub v-if="dashboard.panel == 'trailHub'" />
      <WebCams v-if="dashboard.panel == 'webCams'" />
      <Dining v-if="dashboard.panel == 'dining'" />
      <Activities v-if="dashboard.panel == 'activities'" />
      <CustomTabs v-if="dashboard.panel == 'customTabs'" />
    </div><!-- /.container -->
  </div><!-- /#dashboard -->
</template>

<script>
import Navigation from './Navigation'
import Weather from './Weather'
import TrailHub from './TrailHub'
import WebCams from './WebCams'
import Dining from './Dining'
import Activities from './Activities'
import CustomTabs from './CustomTabs'
import axios from 'axios'
import RingLoader from 'vue-spinner/src/RingLoader'
import { mapState } from 'vuex'

export default {
  components: {
    Navigation,
    Weather,
    TrailHub,
    WebCams,
    Dining,
    Activities,
    CustomTabs,
    RingLoader
  },
  computed: {
    ...mapState([
      'dashboard'
    ])
  },
  mounted() {
    this.$store.commit('spinner', true)
    this.$store.commit('fetchDashboard', {id: this.$route.params.id, customStyles: true})
    if (this.$route.params.pane && this.$route.params.pane !== 'customTabs') {
      this.$store.commit('changePanel', this.$route.params.pane)
    }
    setTimeout(() => {
      this.$store.commit('spinner', false)
    }, 3000)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue